import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import shopifyTasks from "@/store/modules/shopifyTasks";
import tasks from "@/store/modules/tasks";
import app from "@/store/modules/app";
import user from "@/store/modules/user";
import users from "@/store/modules/users";
import settings from "@/store/modules/settings";
import orders from "@/store/modules/orders";
import manualFulfillments from "@/store/modules/manualFulfillments";
import statistics from "@/store/modules/statistics";
import support from "@/store/modules/support";
import counters from "@/store/modules/counters";
import localforage from "localforage";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "taskDash",
  storage: localforage,
  asyncStorage: true,
  reducer: (state) => {
    // Der "Waschgang":
    // 1. JSON.stringify entfernt alle Funktionen (macht es "sauber" aber zu Text)
    // 2. JSON.parse macht daraus wieder ein Objekt
    // Ergebnis: Ein sauberes Objekt ohne Funktionen, das localforage akzeptiert.
    return JSON.parse(
      JSON.stringify({
        app: state.app,
        users: state.users,
        user: state.user,
        settings: state.settings,
      })
    );
  },
});

export default new Vuex.Store({
  modules: {
    app,
    shopifyTasks,
    tasks,
    user,
    users,
    settings,
    orders,
    manualFulfillments,
    statistics,
    support,
    counters,
  },
  plugins: [vuexPersist.plugin],
});
